import { useCallback, useMemo } from 'react';

import { TabBase } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { ShortcutsTabs } from './shortcutsPageTabs/ShortcutsPageTabs.style.ts';
import { ShortcutPages } from './shortcutsPageTabs/types.ts';

type ShortcutsPageTabsProps = {
  currentShortCutPage: ShortcutPages;
  onPageTabChange: (shortCutPage: ShortcutPages) => void;
};

type ShortcutsPageTab = {
  id: string;
  label: string;
  value: ShortcutPages;
  isSelected: boolean;
};

export const ShortcutsPageTabs = ({
  currentShortCutPage,
  onPageTabChange,
}: ShortcutsPageTabsProps) => {
  const { t } = useTranslation(['common']);

  const tabs: ShortcutsPageTab[] = useMemo(
    () => [
      {
        id: ShortcutPages.global.toString(),
        label: t('shortcuts.tabName.global'),
        value: ShortcutPages.global,
        isSelected: currentShortCutPage === ShortcutPages.global,
      },
      {
        id: ShortcutPages.layout.toString(),
        label: t('shortcuts.tabName.layout'),
        value: ShortcutPages.layout,
        isSelected: currentShortCutPage === ShortcutPages.layout,
      },
      {
        id: ShortcutPages.layoutPicker.toString(),
        label: t('shortcuts.tabName.layoutPicker'),
        value: ShortcutPages.layoutPicker,
        isSelected: currentShortCutPage === ShortcutPages.layoutPicker,
      },
      {
        id: ShortcutPages.cameras.toString(),
        label: t('shortcuts.tabName.cameraControl'),
        value: ShortcutPages.cameras,
        isSelected: currentShortCutPage === ShortcutPages.cameras,
      },
      {
        id: ShortcutPages.gamePad.toString(),
        label: t('shortcuts.tabName.gamePad'),
        value: ShortcutPages.gamePad,
        isSelected: currentShortCutPage === ShortcutPages.gamePad,
      },
      {
        id: ShortcutPages.inventory.toString(),
        label: t('shortcuts.tabName.inventory'),
        value: ShortcutPages.inventory,
        isSelected: currentShortCutPage === ShortcutPages.inventory,
      },
    ],
    [currentShortCutPage, t]
  );

  const handlePageTabChange = useCallback(
    (selectedShortcutTab: ShortcutPages) => {
      if (selectedShortcutTab !== undefined && selectedShortcutTab !== currentShortCutPage) {
        onPageTabChange(selectedShortcutTab);
      }
    },
    [onPageTabChange, currentShortCutPage]
  );

  return (
    <>
      <ShortcutsTabs style={{ width: '100%' }}>
        {tabs.map(({ id, value, label, isSelected }) => (
          <TabBase
            key={value}
            id={id}
            selected={isSelected}
            onClick={() => handlePageTabChange(value)}
          >
            {label}
          </TabBase>
        ))}
      </ShortcutsTabs>
    </>
  );
};
